import { useMemo } from 'react';
import AsyncSelect from 'react-select/async';

import { fetchPlacePredictions, debouncePromise } from '../../services/places';

// Drop-in replacement for the `react-google-places-autocomplete` default export, on the new
// Places API (see `../../services/places`). It accepts the same `apiKey` /
// `autocompletionRequest` / `selectProps` props, so existing call sites only swap the import
// and keep their JSX. `selectProps` is spread straight onto react-select's `AsyncSelect`.
// `autocompletionRequest` is accepted for compatibility but unused — its only value,
// `types: ['establishment']`, is a Table-B type the new API rejects in `includedPrimaryTypes`.
export const GooglePlacesAutocomplete = ({ apiKey, autocompletionRequest, selectProps = {}, ...rest }) => {
	void autocompletionRequest;
	const loadOptions = useMemo(() => debouncePromise((input) => fetchPlacePredictions(input, { apiKey }), 300), [apiKey]);

	return <AsyncSelect loadOptions={loadOptions} {...rest} {...selectProps} />;
};
